(function($) {



  $(document).ready(function() {



    /*

     * RESPONSIVE VIDEOS

     * Make videos responsive

    */

    $('.entry-content iframe').each(function(){

        $(this).wrap( '<div class="embed-responsive embed-responsive-16by9"></div>' );

    });





    /**

     * EXTERNAL LINKS

     * Automatically creates a external link icon

     * on externall links

     */

    $('body').find('a[href*="http"]').each(function(){

      if (this.hostname !== location.hostname && !$(this).hasClass('skip-external')) {

        $(this).attr('rel', 'external');

        $(this).append(' <span class="fa fa-external-link"></span><span class="sr-only"><?php _e("Site externo"); ?></span>');

      }

    });



    /**

     * TABLES BOOTSTRAP

     * Automatically creates a external link icon

     * on externall links

     */

    $('body').find('table').each(function(){

      if(!$(this).hasClass('wccpf_fields_table')){

        $(this).addClass('table');

      }

    });



    /**

     * POP-UP SHARE

     * Open share options on a pop-up window

     */

    $('.entry-share a, #section-doe-sua-influencia a').on('click', function(e) {

        var $h = 510, $w = 510,

            px = Math.floor( ((screen.availWidth || 1024) - $w) / 2 ),

            py = Math.floor( ((screen.availHeight || 700) - $h) / 2 );

        var popup = window.open( $(this).attr('href'), 'social',

            'width='+$w+',height='+$h+',left='+px+',top='+py+

            ',location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1');

        if ( popup ) {

            popup.focus();

            e.preventDefault();

        }

        return !!popup;

    }); // pop-up share */



    /**

     * ACTIVE FLAG HIDDEN

     * Insert active class and hides object

     */

    $lang = $('html').attr('lang');

    $('.navbar-lang a').each(function(){

      $target = $(this).attr('data-lang');

      if ($target === $lang) {

        $(this).addClass('active');

      }

    });

    // active flag */



    $('.alert-cookies button').click(function(){

        var d = new Date();

        d.setTime(d.getTime() + (1*24*60*60*1000));

        var expires = "expires="+ d.toUTCString();

        document.cookie = "alert=true;" + expires + ";";

        console.log( document.cookie );

        $('.alert-cookies').alert('close');

    });





    /**

     * CAROUSEL TOUCH

     * Deixar carousel acessivel ao toque

     */

    $(".item").swipe({

      swipe: function(event, direction, distance, duration, fingerCount, fingerData) {



        if (direction === 'left') {

          $(this).parents('.carousel').carousel('next');

        }

        if (direction === 'right') {

          $(this).parents('.carousel').carousel('prev');

        }

      },



      allowPageScroll:"vertical"



    });



    /**

     * VERIFICAR SE CONTEÚDO É VALIDO

     * Executa a verificação em tempo real se o input está preenchiodo

     */

    $("input[type=text]").change(function() {

      if ($(this).attr('value') !== '') {

        $(this).addClass('valid');



      } else {

        $(this).removeClass('valid');



      }

    });





    /**

     * BACK TO TOP

     * return sroll to top page

     */

    $("a[href='#top']").click(function() {

      $("html, body").animate({ scrollTop: 0 }, "slow");

      return false;

    });



    /**

     * MENU DORINA

     * todas as regras para criação do menu

     */

    //

    function resizeScreen() {





      if ($(window).width() > 991) {



        $('#header .menu-item-has-children a[data-toggle="collapse"]').click( function() {

          $('#header .menu-item-has-children .menu-colapse, #menu_pesquisa').not($(this)).collapse('hide');

        });



        /*/

        $('#header .menu-item-has-children a').unbind('click');



        var timeoutSubmenu;



        $('#header .menu-item-has-children a').click( function(e) {

          e.stopPropagation();

          e.preventDefault();



          $(this).blur();



          clearTimeout(timeoutSubmenu);



          $height = $($(this).attr('href')).height();

          $height = $height - 2;



          if ( !$(this).parent().hasClass('active') ) {

            $('.submenu').css('bottom', '0');

            $('.menu-item-has-children').removeClass('active');



            var $submenuAtual = $(this).attr('href');



            $($submenuAtual).css('display', 'block');

            $($submenuAtual).css('bottom', '-'+$height+'px');





            // Change focus

            $first = $($submenuAtual + " li:first-child a");



            setTimeout(function () {

              $( $first.get(0) ).focus();

            }, 50 );



            console.log( $first );



            // /

            $(this).parent().addClass('active');



            timeoutSubmenu = setTimeout(function () {

               $($submenuAtual).siblings('.submenu').css('display', 'none');

            }, 1000);



          } else {

            $('.submenu').css('bottom', '0');

            $(this).parent().removeClass('active');

            $(this).blur();



            timeoutSubmenu = setTimeout(function () {

               $('.submenu').css('display', 'none');

            }, 1000);



          }



          return false;

        });

        $('.submenu a').click(function(){

          $('.submenu').css('bottom', '0');

          $('.menu-item-has-children').removeClass('active');

        });

        // */

      } else {



        $('.menu-principal .menu-item-has-children a').unbind('click');



        $("#principal-toogle").click(function() {

          $('.navbar-collapse, .navbar-content, .bg-navbar-collapse').css('right', '0');

        });



        $(".navbar-close").click(function() {

          $('.navbar-collapse, .navbar-content, .bg-navbar-collapse').css('right', '100%');

        });



        $('.menu-principal .menu-item-has-children a').click( function() {

          $('#header .menu-item-has-children .menu-colapse, #menu_pesquisa').not($(this).attr('href')).collapse('hide');

          //return false;

        }); //*/

      }



    } // */



    var timeoutPesquisa;



    $('#pesquisa').click(function(){



      clearTimeout(timeoutPesquisa);



      $target = $(this).attr('href');



      $height = $($target).height();



      if ( !$($target).hasClass('active') ) {

        $($target).addClass('active');

        $($target).css('display', 'block');

        $($target).css('bottom', '-'+$height+'px');



      } else {

        $($target).removeClass('active');

        $($target).css('bottom', '0');



        timeoutPesquisa = setTimeout(function () {

          $($target).css('display', 'none');

        }, 1000);



      }



      return false;

    });



    resizeScreen();



    $(window).on('resize', function() {

      resizeScreen();

    }); // menu dorina





    /**

     * FIXED HEAD

     * adjust config when scroll

     */

    if ($(window).scrollTop() > 25) { $('#header').addClass('scroll-top'); }



    $(window).scroll(function() {

      if ($(this).scrollTop() > 25) { $('#header').addClass('scroll-top'); }

      else{ $('#header').removeClass('scroll-top'); }

    });



    /**

     * BACKGROUND CARROUSEL

     * pseudo elemento no toogle

     */

    $('#slider-depoimentos').on('slide.bs.carousel', function(e) {

      var num = $(e.relatedTarget).attr('data-slide');

      $('.carousel-indicators').removeClass('slide-0 slide-1 slide-2 slide-3');

      $('.carousel-indicators').addClass('slide-'+num);

    });



    /**

     * CLICK LINHA DO TEMPO

     * Subir conteúdo ao clicar no item da linha do tempo

     */

    $('.timeline').click(function(e) {



      if ( !$(this).hasClass('active'))  {

        $(this).addClass('active');



      } else {

        $(this).removeClass('active');



      }



      return false;



    });



    /**

     * MASCARAS DOS FOMULÁRIOS

     * Padronizar campos dos formulários

     */



    $('.mask_data').mask('99/99/9999');

    $('.mask_cpf, .mask_cpf_container input').mask('999.999.999-99', {reverse: true});

    $('.mask_rg').mask('99.999.999-9');

    $('.mask_cep, .mask_cep_container input').mask('99999-999');

    $('.mask_tel, .mask_tel_container input').mask('(99) 9999-9999?9');



    $('select, textarea').change(function(){



      if($(this).val() !== "") {

        $(this).addClass('valid');

      }



      else {

        $(this).removeClass('valid');

      }



    });





    /**

     * CONTAGEM E BARRA DE RESULTADO

     * Subir conteúdo ao clicar no item da linha do tempo

     */

    $('.counter').counterUp({

      delay: 10,

      time: 2000,

      formatter: function (n) {

        return n.replace(/,/g, '.');

      }

    });



    /**

     * CUSTOM FIELDS CHECKOUT

     * Hide some fields

     */

    $('#ship-to-different-address').css('display', 'none');

    $('.present-institution-container, .rehabilitation-container').css('display', 'none');



    $('.rehabilitation').change(function(){

      //alert($(this).val());

      if ($(this).val() === '1') {

        $('.rehabilitation-container').css('display', 'block');

      }

      if ($(this).val() === '0') {

        $('.rehabilitation-container').css('display', 'none');

      }// */

    });



    $('.present-institution').change(function(){

      //alert($(this).val());

      if ($(this).val() === '1') {

        $('.present-institution-container').css('display', 'block');

      }

      if ($(this).val() === '0') {

        $('.present-institution-container').css('display', 'none');

      }// */

    });



    /**

     * CONTRAST

     * insert and remove high contrast

     *

    $('.high-contrast').click( function(){

      $target = $(this).attr('data-class');

      $('body').removeClass('black-white-yellow');

      $('body').removeClass('black-white');

      $('body').addClass( $target );

      console.log($target);

    }); // contrast */



    /*$('.acao').bind("mouseenter focus", function(event) {

      $porcentagem = $(this).find('.progresso').attr('data-size');

      $(this).find('.progresso').css('width', $porcentagem+'%');



    });*/



    $('.progresso').waypoint(function () {

      $porcentagem = $(this.element).attr('data-size');

      $(this.element).css('width', $porcentagem+'%');

      console.log($(this.element));

    }, { offset: 'bottom-in-view' }

    );



    /**

     * CONTRAST

     * Toggles contrast on/off

     */

    $('.high-contrast').on('click', function(e) {

      e.preventDefault();

      e.stopPropagation();

      $('body').removeClass('black-white-yellow');

      $('body').removeClass('black-white');

      console.log($(this).attr('data-class'));

      $('body').addClass($(this).attr('data-class'));

      $.cookie("contrast", null);

      $.cookie("contrast", $(this).attr('data-class'), {expires:365, path:'/'});

    }); // contrast */





    /**

     * TRACK ANALYTICS

     * track if download click

     */

    function trackAnalytics( eventName, eventTitle, eventDetail ) {

      // Don't allow if parameters are not passed

      if ( eventName === undefined || eventTitle === undefined || eventDetail === undefined) {

        return false;

      }

      if ( typeof ga !== undefined ) {

        ga( 'send', 'event', eventName, eventTitle, eventDetail );

        console.log('Event sent trought "ga"');

        return true;

      }

      if ( typeof _gaq !== undefined ) {

        _gaq.push(['_trackEvent', eventName, eventTitle, eventDetail]);

        console.log('Event sent trought "_gaq"');

        return true;

      }

      if ( typeof __gaTracker !== undefined ) {

        __gaTracker('send', 'event', eventName, eventTitle, eventDetail);

        console.log('Event sent trought "__gaTracker"');

        return true;

      }

      console.log('Event not tracked!');

      return false;

    } // track analytics  */



    // Track external links

    $('body').find('a[href*="http"]').click(function(e){

        if (this.hostname !== location.hostname) {

            e.preventDefault();

            var $href = $(this).attr('href');

            // Track downloads

            trackAnalytics( 'External site', document.title, $href );

            // Set redirect timeout (emulates normal behavior)

            setTimeout( function(){

              window.location.href = $href;

            }, 500);

        }

    });



    // Track file downloads

    $('body').find('a[href$=".doc"], a[href$=".docx"], a[href$=".gzip"], a[href$=".pdf"], a[href$=".rar"], a[href$=".tar.gz"], a[href$=".tar"], a[href$=".xls"], a[href$=".xlsx"], a[href$=".zip"]')

    .click( function(e){

        e.preventDefault();

        // Track downloads

        $file = $(this).attr('href');

        trackAnalytics( 'Download', document.title, $file );

        // Set redirect timeout (emulates normal behavior)

        setTimeout( function(){

          window.location.href = $file;

        }, 500);

    });

    /**

         * MODAL VIDEO

         * Refresh modal contente when close

         */

        $('[data-target="#modal-video"]').on('click', function (e) {

          $video = $(this).attr('data-video');

          $url = 'https://www.youtube.com/embed/'+ $video +'?rel=0&autoplay=1';

          $('#modal-video .modal-body .embed-responsive-item').attr('src', $url );

      });

      $('#modal-video').on('hidden.bs.modal', function (e) {

          $('#modal-video .modal-body .embed-responsive-item').attr('src','');

      });

      $('.modal-close').on('click', function(e){
        $('#modal-video').hide();
      });

      // modal-video */

      $('.site-alert .close').on('click', function(e){
        $('.site-alert').hide();
      });

      //SCROLL + MENU TIMELINE

      var h = $('.box-total').outerHeight();
      var itensMenu = $('.menu-item-tl .smenu li a');

      function verificaAtivo(){

        var qtdItens = $('.box-total').length;

        var scroll = $('.box-itens').scrollTop();


        for (var i = 0; i < qtdItens; i++) {

          if(scroll >= i * h && scroll <= (i+1) * (h)){
            var parentOld = $('.menu-item-tl .item' + (i - 1)).parent().parent().attr('id');
            var parentAtual = $('.menu-item-tl .item' + (i)).parent().parent().attr('id');
            var parentNext = $('.menu-item-tl .item' + (i + 1)).parent().parent().attr('id');
            if(i === 0){ 
              if(!$('#'+parentAtual).hasClass('in')){
                $('.menu-item-tl .smenu').removeClass('in');
                $('.menu-item-tl .smenu').removeClass('show');
                $('.menu-item-tl .smenu').siblings('.dd-toggle').attr('aria-expanded', 'false');
                $('#'+parentAtual).addClass('in');
                $('#'+parentAtual).siblings('.dd-toggle').attr('aria-expanded', 'true');
              }
            }
            if(parentOld !== parentAtual || parentNext !== parentAtual){
              if(!$('#'+parentAtual).hasClass('in')){
                $('.menu-item-tl .smenu').removeClass('in');
                $('.menu-item-tl .smenu').removeClass('show');
                $('.menu-item-tl .smenu').siblings('.dd-toggle').attr('aria-expanded', 'false');
                $('#'+parentAtual).addClass('in');
                $('#'+parentAtual).siblings('.dd-toggle').attr('aria-expanded', 'true');
              }
            }

            itensMenu.removeClass('active');

            $('.menu-item-tl .item' + (i)).addClass('active');

          }else{

            $('.item' + (i)).removeClass('active');

          }

        }

      }

      itensMenu.each(function(key, value){
        var target = $(this).data("target");
        if(window.innerWidth <= 768){
          $(this).attr('href', target);
        }
        $(this).click(function(e){
          e.preventDefault();
          $('.box-itens').off('scroll');
          itensMenu.removeClass('active');
          $('.menu-item-tl .smenu').removeClass('in');
          $('.menu-item-tl .smenu').removeClass('show');
          $('.menu-item-tl .smenu').siblings('.dd-toggle').attr('aria-expanded', 'false');
          $('.box-itens').animate({
            scrollTop: $($(this).data("target")).outerHeight() * key
          }, 100, function(){
            setTimeout(function(){
              $('.box-itens').on('scroll', function(){
                verificaAtivo();
              });
            }, 2500);
          });
          $(this).parent().parent().addClass('in');
          $(this).parent().parent().addClass('show');
          $(this).parent().parent().siblings('.dd-toggle').attr('aria-expanded', 'true');
          $(this).addClass('active');
        });
      });

      $('.box-itens').on('scroll', function(){
        verificaAtivo();
      });

      $('.menu-item-tl .main-cat').on('click', function(e){
        e.preventDefault();
        $('.menu-item-tl .main-cat').siblings('.smenu').removeClass('in');
        $('.menu-item-tl .main-cat').siblings('.smenu').removeClass('show');
        if($(this).attr('aria-expanded')==='false'){
          $('.menu-item-tl .main-cat').attr('aria-expanded', 'false');
          $(this).attr('aria-expanded', 'true');
        }
      });

      // FIM SCROLL + MENU TIMELINE

      //BOTÃO OCULTAR TEXTO

      $('.btn-img').click(function(e){
        e.preventDefault();
        if($(this).text() === "Ocultar texto"){
          $(this).parent().siblings('.box-txt-tl').hide();
          $(this).text('Exibir texto');
        }else if($(this).text() === "Exibir texto"){
          $(this).parent().siblings('.box-txt-tl').show();
          $(this).text('Ocultar texto');
        }
      });

      if(window.innerWidth <= 768){
        $('.tl-header #sidebar-menu').addClass('collapse');
      }

      //FIM BOTÃO OCULTAR TEXTO
      
      //MENU MOBILE
      var timelineTL = $('.ct-timeline');
      var mobMenu = $('.box-menu-tl');
      var position = $(window).scrollTop(); 

      if(window.innerWidth <= 768){
        $(window).scroll(function() {
          var scroll = $(window).scrollTop();
          if($(window).scrollTop() >= timelineTL.position().top - 40){
            mobMenu.css({
              'position': 'fixed',
              'top': '50px',
              'z-index': '5'
            });
          }else{
            mobMenu.css({
              'position': 'relative',
              'top': '0',
              'z-index': '5'
            });
          }
          position = scroll;
        });
        itensMenu.click(function(){
          $('.tl-header #sidebar-menu').removeClass('in');
          $('.tl-header #sidebar-menu').removeClass('show');
          $('.tl-header button#timeline-toogle').attr('aria-expanded', 'false');
        });
      }

      //FIM MENU MOBILE

      // AUDIOS DA TIMELINE

      function audioExists(){
        var audioPlayer = document.querySelector('.ct-timeline .green-audio-player');
        var playPause = audioPlayer.querySelector('.ct-timeline #playPause');
        var playpauseBtn = audioPlayer.querySelector('.ct-timeline .play-pause-btn');
        var loading = audioPlayer.querySelector('.ct-timeline .loading');
        var progress = audioPlayer.querySelector('.ct-timeline .progress');
        var sliders = audioPlayer.querySelectorAll('.ct-timeline .slider');
        var volumeBtn = audioPlayer.querySelector('.ct-timeline .volume-btn');
        var volumeControls = audioPlayer.querySelector('.ct-timeline .volume-controls');
        var volumeProgress = volumeControls.querySelector('.ct-timeline .slider .progress');
        var player = audioPlayer.querySelector('.ct-timeline audio');
        var currentTime = audioPlayer.querySelector('.current-time');
        var totalTime = audioPlayer.querySelector('.ct-timeline .total-time');
        var speaker = audioPlayer.querySelector('.ct-timeline #speaker');

        var draggableClasses = ['pin'];
        var currentlyDragged = null;

        function isDraggable(el) {
          var canDrag = false;
          var classes = Array.from(el.classList);
          draggableClasses.forEach(function(draggable) {
            if(classes.indexOf(draggable) !== -1){
              canDrag = true;
            }
          });
          return canDrag;
        }

        function getRangeBox(event) {
          var rangeBox = event.target;
          var el = currentlyDragged;
          if(event.type === 'click' && isDraggable(event.target)) {
            rangeBox = event.target.parentElement.parentElement;
          }
          if(event.type === 'mousemove') {
            rangeBox = el.parentElement.parentElement;
          }
          return rangeBox;
        }

        function updateVolume() {
          volumeProgress.style.height = player.volume * 100 + '%';
          if(player.volume >= 0.5) {
            speaker.attributes.d.value = 'M14.667 0v2.747c3.853 1.146 6.666 4.72 6.666 8.946 0 4.227-2.813 7.787-6.666 8.934v2.76C20 22.173 24 17.4 24 11.693 24 5.987 20 1.213 14.667 0zM18 11.693c0-2.36-1.333-4.386-3.333-5.373v10.707c2-.947 3.333-2.987 3.333-5.334zm-18-4v8h5.333L12 22.36V1.027L5.333 7.693H0z';  
          } else if(player.volume < 0.5 && player.volume > 0.05) {
            speaker.attributes.d.value = 'M0 7.667v8h5.333L12 22.333V1L5.333 7.667M17.333 11.373C17.333 9.013 16 6.987 14 6v10.707c2-.947 3.333-2.987 3.333-5.334z';
          } else if(player.volume <= 0.05) {
            speaker.attributes.d.value = 'M0 7.667v8h5.333L12 22.333V1L5.333 7.667';
          }
        }

        function formatTime(time) {
          var min = Math.floor(time / 60);
          var sec = Math.floor(time % 60);
          var tempo = min + ':' + ((sec<10) ? ('0' + sec) : sec);
          return tempo;
        }

        function togglePlay() {
          if(player.paused) {
            playPause.attributes.d.value = "M0 0h6v24H0zM12 0h6v24h-6z";
            player.play();
          } else {
            playPause.attributes.d.value = "M18 12L0 24V0";
            player.pause();
          }  
        }

        function makePlay() {
          playpauseBtn.style.display = 'block';
          loading.style.display = 'none';
        }

        function directionAware() {
          if(window.innerHeight < 250) {
            volumeControls.style.bottom = '-54px';
            volumeControls.style.left = '54px';
          } else if(audioPlayer.offsetTop < 154) {
            volumeControls.style.bottom = '-164px';
            volumeControls.style.left = '-3px';
          } else {
            volumeControls.style.bottom = '52px';
            volumeControls.style.left = '-3px';
          }
        }

        function updateProgress() {
          var current = player.currentTime;
          var percent = (current / player.duration) * 100;
          progress.style.width = percent + '%';
          
          //currentTime.innerHTML = formatTime(current);
        }

        window.addEventListener('mousedown', function(event) {
          
          if(!isDraggable(event.target)){ return false; }
          
          currentlyDragged = event.target;
          var handleMethod = currentlyDragged.dataset.method;
          
          this.addEventListener('mousemove', window[handleMethod], false);

          window.addEventListener('mouseup', function(){
            currentlyDragged = false;
            window.removeEventListener('mousemove', window[handleMethod], false);
          }, false);  
        });

        function mudandoTempo(){
          if(player){
            totalTime.innerHTML = formatTime(player.duration);
          }
        }

        playpauseBtn.addEventListener('click', togglePlay);
        player.addEventListener('timeupdate', updateProgress);
        player.addEventListener('volumechange', updateVolume);
        player.onloadeddata = mudandoTempo();
        player.oncanplay = makePlay();
        player.onended = function(){
          playPause.attributes.d.value = "M18 12L0 24V0";
          player.currentTime = 0;
        };

        volumeBtn.addEventListener('click', function(){
          volumeBtn.classList.toggle('open');
          volumeControls.classList.toggle('hidden');
        });

        window.addEventListener('resize', directionAware);

        sliders.forEach(function(slider) {
          var pin = slider.querySelector('.pin');
          slider.addEventListener('click', window[pin.dataset.method]);
        });

        directionAware();

        function inRange(event) {
          var rangeBox = getRangeBox(event);
          var rect = rangeBox.getBoundingClientRect();
          var direction = rangeBox.dataset.direction;
          var min;
          var max;
          if(direction === 'horizontal') {
            min = rangeBox.offsetLeft;
            max = min + rangeBox.offsetWidth;   
            if(event.clientX < min || event.clientX > max){ return false; }
          } else {
            min = rect.top;
            max = min + rangeBox.offsetHeight; 
            if(event.clientY < min || event.clientY > max){ return false; }
          }
          return true;
        }

        function getCoefficient(event) {
          var slider = getRangeBox(event);
          var rect = slider.getBoundingClientRect();
          var K = 0;
          if(slider.dataset.direction === 'horizontal') {
            
            var offsetX = event.clientX - slider.offsetLeft;
            var width = slider.clientWidth;
            K = offsetX / width;    
            
          } else if(slider.dataset.direction === 'vertical') {
            
            var height = slider.clientHeight;
            var offsetY = event.clientY - rect.top;
            K = 1 - offsetY / height;
            
          }
          return K;
        }

        function rewind(event) {
          if(inRange(event)) {
            player.currentTime = player.duration * getCoefficient(event);
          }
        }

        function changeVolume(event) {
          if(inRange(event)) {
            player.volume = getCoefficient(event);
          }
        }
      }

      setTimeout(function(){
        if($('audio')){
          audioExists();
        }
      }, 1000);

      //SOLUÇÕES EM ACESSIBILIDADE

      var sol_input = $('.form-solucoes input[type=text], .form-solucoes input[type=email], .form-solucoes textarea');

      sol_input.on('focusin', function(){
        $(this).siblings().animate({
          top: "0px",
          "font-size": "16px"
        }, 300);
      });

      sol_input.on('focusout', function(){
        if($(this).val().length == 0){
          $(this).siblings().animate({
            top: "17px",
            "font-size": "24px"
          }, 300);
        }else{
          if($(this).attr('id') == 'phone' || $(this).attr('id') == 'mobile'){
            if($(this).val().length > 10){
              $(this).mask("(99) 99999-999?9");
            }else{
              $(this).mask("(99) 9999-9999?9");
            }
          }
        }
      });

  }); // document.ready



  /**

   * jQuery Cookie plugin

   *

   * Copyright (c) 2010 Klaus Hartl (stilbuero.de)

   * Dual licensed under the MIT and GPL licenses:

   * http://www.opensource.org/licenses/mit-license.php

   * http://www.gnu.org/licenses/gpl.html

   *

   */

  jQuery.cookie=function(e,n,o){if(arguments.length>1&&"[object Object]"!==String(n)){if(o=jQuery.extend({},o),(null===n||void 0===n)&&(o.expires=-1),"number"===typeof o.expires){var t=o.expires,r=o.expires=new Date();r.setDate(r.getDate()+t);}return n=String(n),document.cookie=[encodeURIComponent(e),"=",o.raw?n:encodeURIComponent(n),o.expires?"; expires="+o.expires.toUTCString():"",o.path?"; path="+o.path:"",o.domain?"; domain="+o.domain:"",o.secure?"; secure":""].join("");}o=n||{};var i,c=o.raw?function(e){return e;}:decodeURIComponent;return(i=new RegExp("(?:^|; )"+encodeURIComponent(e)+"=([^;]*)").exec(document.cookie))?c(i[1]):null;};


})(jQuery);

